import { Component, OnInit, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MaterialModule } from '../../../material/material.module';
import { CommonModule } from '@angular/common';
import moment, { Moment } from 'moment';
import { PositionPipe } from '../../../shared/pipes/position.pipe';


@Component({
    selector: 'app-note-card',
    imports: [CommonModule, RouterModule, MaterialModule, PositionPipe, MatIconModule, MatCardModule],
    templateUrl: './note-card.component.html',
    styleUrls: ['./note-card.component.css']
})
export class NoteCardComponent implements OnInit {

  @Input() Note: FlowItemModel;
  constructor(private _router: Router) { }



  ngOnInit() {
  }

  gotoPlayerDetails(playerid: string){
    this._router.navigateByUrl('/player/details/' + playerid );

  }


    getTimeAgo(){
      moment.locale(localStorage.getItem("language")?.substring(0, 2) ?? 'en');
      return moment(this.Note.DateCreated).fromNow();
    }

}
